import { render, staticRenderFns } from "./StandardCostCalculation.vue?vue&type=template&id=304429e4&scoped=true"
import script from "./StandardCostCalculation.vue?vue&type=script&lang=js"
export * from "./StandardCostCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304429e4",
  null
  
)

export default component.exports